export default {"src":"/_next/static/media/bookmark-fill.d0ef8eb7.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};